import * as React from 'react';
import { observer } from 'mobx-react';

import { useLocalStore } from 'shared/entities/common/hooks';
import { useRootStore } from 'stores/index';
import { NewsStore, NewsStoreProvider } from 'stores/newsStore';

import NewsModalContent from './NewsModalContent';

type NewsModalProps = {
  isFeedEnabled: boolean;
  managerId: string | undefined;
};

const NewsModal: React.FC<NewsModalProps> = ({ isFeedEnabled, managerId }) => {
  const rootStore = useRootStore();
  const newsStoreCtx = useLocalStore<NewsStore>(() => new NewsStore(rootStore));
  const { store } = newsStoreCtx;

  React.useEffect(() => {
    store.reset();

    if (managerId && isFeedEnabled) {
      store.loadFeed();
    }
  }, [isFeedEnabled, managerId, store]);

  return (
    <NewsStoreProvider value={newsStoreCtx}>
      {store.hasNews && <NewsModalContent />}
    </NewsStoreProvider>
  );
};

export default observer(NewsModal);
